import { render } from "./ParagraphText.vue?vue&type=template&id=0f881380&scoped=true"
import script from "./ParagraphText.vue?vue&type=script&lang=js"
export * from "./ParagraphText.vue?vue&type=script&lang=js"

import "./ParagraphText.vue?vue&type=style&index=0&id=0f881380&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f881380"]])

export default __exports__